var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show !== null)?_c('dialogQRCode',{ref:"dialogQRCode",attrs:{"textOfQRCode":_vm.textOfQRCode,"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }